const TOS = () => {
  return (
    <div id="Container">
      <div className="tosTitle">
        <span className="subTitle">이용약관</span>
        <span className="mainTitle">SHIFT 서비스 이용약관</span>
      </div>
      <div className="tosContent">
        <section>
          <div className="tosContentTitle">
            <span>제 1조&nbsp;&nbsp;&nbsp;&nbsp;(목적)</span>
          </div>
          <div className="tosContentText">
            <span>
              1. 본 약관은 메타세콰이어가 운영하는 인터넷 사이트
              'http://shift2me.com' (이하 '사이트'라 합니다) 및 이를 통해
              제공되는 전자상거래 서비스와 관련하여 당사자의 권리 의무 및
              책임사항을 규정하는 것을 목적으로 합니다.
              <br />
              2. PC통신, 무선 등을 이용하는 전자상거래에 대하여도 그 성질에
              반하지 않는 한 본 약관을 준용합니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 2조&nbsp;&nbsp;&nbsp;&nbsp;(정의)</span>
          </div>
          <div className="tosContentText">
            <span>
              본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <br />
              <br />
              1. '회사'라함은, 메타세콰이어이 재화 또는 용역(이하
              ‘상품’이라합니다)을 제공하기 위하여 컴퓨터 등 정보 통신 설비를
              이용하여 상품을 거래할 수 있도록 설정한 가상의 영업장을 운영하는
              주체를 말하며, 아울러 'http://shift2me.com'을 통해 제공되는
              전자상거래 관련 서비스의 의미로도 사용합니다.
              <br />
              2. '모바일앱'이라 함은, '회사'가 개발 및 운영을 담당하고,
              '이용자'의 편의를 위하여 제공하는 모바일 애플리케이션을 말합니다.
              <br />
              3. '이용자’라 함은, '사이트'에 접속하여 '회사'의 이용약관에 따라
              '회사가 제공하는 서비스를 받은 '회원’ 및 '비회원’을 말합니다.
              <br />
              4. '회원'이라 함은 '회사'에 개인정보를 제공하여 회원가입을 한
              자로서, '회사'로부터 서비스 제공에 관한 정보를 지속적으로
              제공받으며, '회사’가 제공하는 서비스를 계속적으로 이용할 수 있는
              자를 말합니다.
              <br />
              5. '비회원’이라 함은 '회원'으로 가입하지 않고 회사가 제공하는
              서비스를 이용하는 자를 말합니다.
              <br />
              6.'구매자’라 함은, 상품을 구입할 의사를 '회사가 제공하는 양식’에
              맞추어 전달한 이용자를 말합니다.
              <br />
              7. '상품'이라 함은, '판매자'가 ‘사이트’를 통하여 판매하는 재화 및
              용역 등 일체의 서비스를 말합니다.
              <br />
              8. 본 조에서 정의되지 않은 본 약관 상의 용어는 일반적인 거래관행에
              따라 해석합니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 3조&nbsp;&nbsp;&nbsp;&nbsp;(약관 외 준칙)</span>
          </div>
          <div className="tosContentText">
            <span>
              본 약관에서 정하지 아니한 사항은 법령 또는 '회사'가 정한 서비스의
              개별 약관, 운영정책 및 규칙(이하 '세부지침'이라 합니다)의 규정에
              다릅니다. 또한 본 약관과 세부지침이 충돌할 경우에는 세부지침이
              우선합니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 4조&nbsp;&nbsp;&nbsp;&nbsp;(약관의 명시 및 개정)</span>
          </div>
          <div className="tosContentText">
            <span>
              1. '회사'는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지,
              전화번호, 전자우편 주소, 사업자등록번호, 통신판매업신고번호 등을
              '이용자’가 쉽게 알 수 있도록 ’사이트’의 초기 서비스화면에
              게시합니다. 다만, 본 약관의 내용은 ’이용자’가 연결화면을 통하여
              확인할 수 있도록 할 수 있습니다.
              <br />
              2. '회사'는 '이용자가 약관에 동의하기에 앞서 약관에 정해진 내용 중
              개인정보 수집 및 이용 등과 같은 내용을 '이용자'가 이해할 수 있도록
              별도의 연결화면 또는 팝업화면 등을 통하여 '이용자’의 확인을
              구합니다.
              <br />
              3. '회사'는 전자상거래 등에서의 소비자보호에 관한 법률，'약관의
              규제에 관한 법률’, ’전자거래기본법’, ’정보통신망 이용촉진 등에
              관한 법률', '소비자보호법’ 등 관계 법령 (이하 '관계법령'이라
              합니다.）에 위배되지 않는 범위 내에서 본 약관을 개정할 수
              있습니다.
              <br />
              4. '회사'가 본 약관을 개정하고자 할 경우, 적용일자 및 개정사유를
              명시하여 현행약관과 함께 사이트 초기화면에 그 적용일자 7일전부터
              적용일자 전날까지 공지합니다. 다만, '이용자'에게 불리한 내용으로
              약관을 변경하는 경우 최소 30일 이상 유예기간을 두고 공지합니다.
              <br />
              5. '회사'가 본 약관을 개정한 경우，개정약관은 적용일자 이후
              체결되는 계약에만 적용되며 적용일자 이전 체결된 계약은 개정 전
              약관이 적용됩니다. 다만, 이미 계약을 체결한 '이용자'가 개정약관의
              내용을 적용받고자 하는 뜻을 ’회사’에게 전달하고, ’회사’가 여기에
              동의한 경우 개정약관을 적용합니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 5조&nbsp;&nbsp;&nbsp;&nbsp;(서비스의 제공 및 변경)</span>
          </div>
          <div className="tosContentText">
            <span>
              1. ‘회사’가 제공하는 서비스는 연중무휴, 1일 24시간 제공을 원칙으로
              합니다. 다만, '사이트’ 시스템의 유지 보수를 위한 점검, 통신장비의
              교체 등 특별한 사유가 있는 경우 서비스의 전부 또는 일부에 대하여
              일시적인 제공 중단이 발생할 수 있습니다.
              <br />
              2. '회사'는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가
              발생하거나 발생할 우려가 있는 경우, 전기통신사업법에 의한
              기간통신사업자가 전기통신서비스를 중지하는 등 부득이한 사유가
              발생한 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수
              있습니다.
              <br />
              3. '회사'가 서비스를 정지하거나 이용을 제한하는 경우 그 사유 및
              기간, 복구 예정 일시 등을 지체 없이 '이용자’에게 알립니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 6조&nbsp;&nbsp;&nbsp;&nbsp;(회원가입 및 승낙)</span>
          </div>
          <div className="tosContentText">
            <span>
              1. 회원가입은 '회원'이 되고자 하는 '이용자’가 약관의 내용에 동의를
              하고, 회사가 정한 가입 양식에 따라 회원정보 (이용자ID, 비밀번호,
              주소, 연락처 등)를 기입하여 회원가입 신청을 하고 회사가 이러한
              신청에 대하여 승인함으로써 체결됩니다.
              <br />
              2. '이용자'의 회원가입신청에 대하여 ’회사'가 승낙한 경우, '회사'는
              이용자 ID 및 비밀번호 기타 '회사'가 필요하다고 인정하는 내용을
              '이용자’에게 통지합니다.
              <br />
              3. '회사'는 '이용자’의 신청에 대해서 회원가입을 승낙하는 것을
              원칙으로 합니다. 다만, 다음 각 호에 해당하는 경우에 대하여는
              승인을 하지 아니할 수 있습니다.
              <br />
              가. 본인의 정보가 아닌, 타인의 정보를 도용하여 신청한 경우
              <br />
              나. 신청서의 내용을 허위로 기재한 경우
              <br />
              다. 관계법령 또는 공서양속에 반하는 신청의 경우
              <br />
              라. 부정한 목적으로 본 서비스를이용하고자 하는경우
              <br />
              마. 기타 ’회원’으로 등록하는 것이 적절하지 않은 것으로 판단되는
              경우
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 7조&nbsp;&nbsp;&nbsp;&nbsp;(제공하는 서비스)</span>
          </div>
          <div className="tosContentText">
            <span>
              회사가 제공하는 서비스는 다음과 같습니다.
              <br />
              1. 플랫폼 운영서비스
              <br />
              2.기타 '회사'가 정하는 서비스
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle">
            <span>제 8조&nbsp;&nbsp;&nbsp;&nbsp;(회원에 대한 통지)</span>
          </div>
          <div className="tosContentText">
            <span>
              1. '회사'가 '회원'에 대한 통지를 하는 경우, 가입 시 기입한
              전자우편 주소로 할 수 있습니다.
              <br />
              2. '회사'가 불특정 다수 '회원'에 대하여 통지를 하는 경우, 1주일
              이상 '사이트'의 게시판 또는 연결 화면을 통해 공지할 수 있습니다.
            </span>
          </div>
        </section>
        <section>
          <div className="tosContentTitle" style={{ fontSize: '0.6rem' }}>
            <span>
              {'<'}부칙{'>'}
            </span>
          </div>
          <div className="tosContentText">
            <span>
              1. 이 약관은 2024년 4월 31일부터 적용됩니다.
              <br />
              담당자: 이유빈
              <br />
              e-mail: godsaenglab@gmail.com
            </span>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TOS;
